import moment from "moment";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import configure from "configure";

export const paymentAlertColumns = (onTick = () => { }, onView = () => { }) => [
    {
        Header: "Sr No",
        accessor: "sr_no",
        title: "Sr No",
        isInfoIcon: false,
        className: "project_id text-center",
        Cell: (cellProps) => (
            <div className="text-center">{cellProps?.row?.index + 1}</div>
        ),
    },
    {
        Header: "Project Name",
        title: "Project Name",
        accessor: "project_name",
        isInfoIcon: false,
        className: "col-2",
        Cell: (cellProps) => (
            <div>{cellProps?.row?.original?.project_name || "-"}</div>
        ),
    },
    {
        Header: "Customer",
        title: "Customer",
        accessor: "customer",
        isInfoIcon: false,
        className: "col-2",
        Cell: (cellProps) => <div>{cellProps?.row?.original?.customer || "-"}</div>,
    },
    {
        Header: "Milestone",
        title: "Payment Milestone",
        accessor: "milestone",
        isInfoIcon: false,
        className: "col-2",
        Cell: (cellProps) => (
            <div>{cellProps?.row?.original?.milestone || "-"}</div>
        ),
    },
    {
        Header: "Trigger",
        accessor: "trigger_info",
        className: "col-2 text-center",
        Cell: (cellProps) => {
            const { milestone_type, trigger_info } = cellProps?.row?.original || {};
            return (
                <div className="text-center">
                    {milestone_type === "advance" ? (
                        <span className="badge bg-primary">Advance</span>
                    ) : (
                        <span className="badge bg-success">{trigger_info}</span>
                    )}
                </div>
            );
        },
    },
    // {
    //   Header: "Amount to be paid",
    //   title: "Amount to be paid",
    //   accessor: "percent",
    //   isInfoIcon: false,
    //   className: "col-2 text-center",
    //   Cell: cellProps => {
    //     const row = cellProps?.row?.original || {}
    //     const percent = parseFloat(row.percent)
    //     const cost = parseFloat(row.projectcost)
    //     if (!isNaN(cost) && cost > 0 && !isNaN(percent)) {
    //       const amount = (cost * percent) / 100
    //       return (
    //         <div className="text-center">
    //           {amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
    //           <span className="text-muted ms-1">({percent}%)</span>
    //         </div>
    //       )
    //     }
    //     // No project cost available — show percent only
    //     return (
    //       <div className="text-center">
    //         {isNaN(percent) ? "-" : `${percent}%`}
    //       </div>
    //     )
    //   },
    // },
    {
        Header: "Amount to be paid",
        title: "Amount to be paid",
        accessor: "percent",
        isInfoIcon: false,
        className: "col-2 text-center",
        Cell: (cellProps) => {
            const row = cellProps?.row?.original || {};
            const percent = parseFloat(row.percent);
            const amount = parseFloat(row.amount_to_be_paid); // :point_left: was row.projectcost calculation

            if (!isNaN(amount) && amount > 0) {
                return (
                    <div className="text-center">
                        {amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                        <span className="text-muted ms-1">({percent}%)</span>
                    </div>
                );
            }

            // No contract value available — show percent only
            return (
                <div className="text-center">
                    {isNaN(percent) ? "-" : `${percent}%`}
                </div>
            );
        },
    },
    {
        Header: "Progress",
        title: "Progress",
        accessor: "progress",
        isInfoIcon: false,
        className: "col-1 text-center",
        Cell: (cellProps) => {
            const progress = cellProps?.row?.original?.progress || "0/0";
            const [completed, total] = progress.split("/").map(Number);
            const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
            return (
                <div className="text-center">
                    <div
                        className="progress"
                        style={{ height: "6px", marginBottom: "4px" }}
                    >
                        <div
                            className="progress-bar bg-success"
                            style={{ width: `${pct}%` }}
                        />
                    </div>
                    <small>
                        {progress} ({pct}%)
                    </small>
                </div>
            );
        },
    },
//     {
//         Header: "Action",
//         accessor: "action",
//         isInfoIcon: false,
//         className: "text-center",
//         Cell: (cellProps) => {
//             const row = cellProps?.row?.original || {};
//             return (
//                 // <div className="text-center">
//                 <div className="d-flex justify-content-center align-items-center gap-1">
//                     <button
//                         type="button"
//                         title="Mark as done"
//                         className="btn btn-sm btn-outline-secondary me-1"
//                         onClick={() => onTick(row)}
//                     >
//                         {/* <i className="fas fa-check"></i> */}
//                         <i className="bi bi-check-lg icon-center"></i>
//                     </button>
//                     {/* <Link to={`${configure.appUrl}work/edit-project/${row.project_id}`} */}
//                     {/* <Link
//             to={`${configure.appUrl}performa_invoice/ztpl#lead`}
//             title="view"
//             className="btn btn-sm btn-outline-secondary me-1"
//           >
//             <i className="fas fa-eye "></i>
//           </Link> */}
//                     <button
//                         type="button"
//                         title="View"
//                         className="btn btn-sm btn-outline-secondary me-1"
//                         onClick={() => onView(row)}
//                     >
//                         <i className="fas fa-eye"></i>
//                     </button>
//                 </div>
//             );
//         },
//     },
];